



















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

export interface ReorderNotificationDep {
  title?: string
  descriptions: string[]
  link: string
  buttonLabel: string
}

@Component
export default class ReorderNotification extends Vue {
  @Prop({ required: true })
  readonly dep: ReorderNotificationDep

  onClick(): void {
    this.$router.push(this.dep.link)
  }
}
